module.exports = __webpack_public_path__ + "static/media/holidays-icon.1e555ccc.svg";